import { ExpAPI } from '@pes-ui/components/dist/types/global-types/api/exp-api';
import { getData } from '../globals/utils';
import { IProductCardIdRegular, IProductCardIdSoftware } from '@pes-ui/components/dist/types/components/products-carousel/types';
import { ProductsApi } from '@pes-ui/components/dist/types/global-types/api/products-api';

const storage = window.localStorage;
const STORAGE_KEY = 'recentlyViewed';

export class RecentlyViewService {
    private url: string;
    private maxItems: number;

    constructor(url: string, maxItems: number) {
        this.url = url;
        this.maxItems = maxItems;
    }

    private static instance: RecentlyViewService = null;

    private getIds(currentId: string) {
        const ids = storage.getItem(STORAGE_KEY) || '';

        return ids
            .split(',')
            .filter((id) => id !== currentId)
            .slice(0, this.maxItems)
            .join(',');
    }

    public static getInstance(url: string, maxItems: number): RecentlyViewService {
        if (!RecentlyViewService.instance) {
            RecentlyViewService.instance = new RecentlyViewService(url, maxItems);
        }
        return RecentlyViewService.instance;
    }

    public add(currentId: string): void {
        const ids = this.getIds(currentId);
        const recentlyViewed = ids ? `${currentId},${ids}` : currentId;

        storage.setItem(STORAGE_KEY, recentlyViewed);
    }

    public async getProducts(currentId: string): Promise<(IProductCardIdRegular | IProductCardIdSoftware)[]> {
        const ids = this.getIds(currentId);

        return getData(false, `${this.url}${ids}`)
        .then((res: ExpAPI.getProductCardMain): (IProductCardIdRegular | IProductCardIdSoftware)[] => {
            const products = res?.products || [];
            return products.map((product: ProductsApi.Product) => ({
                name: product.commercialReference,
                description: product.description,
                productUrl: product.pdpUrl,
                imageTitle: product.pictureAltText,
                imageUrl: product.pictureUrl,
                softwareType: undefined, //not sent by backend
                price: product.price,
                version: undefined, //not sent by backend
            }));
        })
        .catch((e) => console.error(e, 'Error while requesting recently viewed products'));
    }
}
